import { useState } from "preact/hooks";
import api from "../services/api";
import { ensureAuthToken } from "~/utils/auth";
import classnames from "classnames";
import style from "./CreatePost.scss";

export default function CreatePost() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    if (!title.trim()) {
      setError("请输入标题");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      // 确保有授权令牌
      await ensureAuthToken();
      const res = await api.post("/api/posts", { title, content });
      const created = res.data;
      if (created && created.id) {
        window.history.pushState(null, "", `/post/${created.id}`);
      } else {
        window.history.pushState(null, "", `/`);
      }
    } catch (e: any) {
      setError(e?.message || "提交失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classnames(style.container, style.createPostPage)}>
      <div className={style.pageHeader}>
        <h2>新建博客</h2>
      </div>
      <form onSubmit={handleSubmit} className={style.form}>
        <div className={style.field}>
          <label>
            标题
            <input
              className={style.input}
              value={title}
              onChange={(e) => setTitle((e.target as HTMLInputElement).value)}
              placeholder="输入标题"
            />
          </label>
        </div>

        <div className={style.field}>
          <label>
            内容
            <textarea
              className={style.textarea}
              value={content}
              onChange={(e) =>
                setContent((e.target as HTMLTextAreaElement).value)
              }
              rows={10}
              placeholder="输入内容"
            />
          </label>
        </div>

        {error && <div className={style.error}>{error}</div>}

        <div className={style.actions}>
          <button type="submit" disabled={loading} className={classnames(style.btn, style.primary)}>
            {loading ? "提交中..." : "提交"}
          </button>
        </div>
      </form>
    </div>
  );
}
